export const AceHeart = ({ size = 18, className = "" }) => (
  <svg
    viewBox="0 0 24 32"
    width={size}
    height={Math.round(size * 1.33)}
    className={className}
    aria-hidden="true"
  >
    <rect x="1" y="1" width="22" height="30" rx="4" fill="#FFFDF9" stroke="#C86D51" strokeWidth="1.5" />
    <path
      d="M12 21.5 C8 18 5.8 15.2 5.8 12.9 C5.8 10.9 7.3 9.6 9 9.6 C10.2 9.6 11.3 10.4 12 11.5 C12.7 10.4 13.8 9.6 15 9.6 C16.7 9.6 18.2 10.9 18.2 12.9 C18.2 15.2 16 18 12 21.5 Z"
      fill="#C86D51"
    />
    <text x="3.6" y="8.4" fontSize="6.5" fill="#C86D51" fontFamily="Georgia, serif" fontWeight="bold">A</text>
    <text x="20.4" y="27.6" fontSize="6.5" fill="#C86D51" fontFamily="Georgia, serif" fontWeight="bold" textAnchor="end" transform="rotate(180 18.5 25.5)">A</text>
  </svg>
);
